<template>
  <div class="main justify-content-center" id="about">
    <img src="../assets/shapes04.svg" id="shapesfour" alt="" />
    <img src="../assets/shapes05.svg" id="shapesfive" alt="" />
    <img src="../assets/shapes06.svg" id="shapessix" alt="" />

    <div class="jumbotron bg-transparent mb-0 radius-0">
      <h1 class="display-3">Hello, im Pau<span class="vim-caret">l</span>!</h1>
      <vue-typed-js
        class="my-2 text-success text-mono"
        :strings="['Manila, Philippines']"
        :loop="true"
        :contentType="html"
        :backDelay="2000"
        :backSpeed="50"
        :startDelay="1000"
        :typeSpeed="70"
        style="font-size: 1em"
      >
        <span class="typing"></span>
      </vue-typed-js>
      <p class="lead">
        a self-taught frontend web developer and a third-year computer science
        student at
        <a
          class="font-weight-bold btn btn-secondary btn-shadow mb-1"
          href="https://iacademy.edu.ph/index.php"
          >iACADEMY</a
        >
      </p>
      <p class="lead">
        I'm currently learning
        <a
          class="btn btn-warning btn-shadow p-1 mr-1"
          href="https://en.wikipedia.org/wiki/JavaScript"
          >Javascript</a
        >
        ,<a
          class="btn btn-success btn-shadow p-1 mr-1"
          href="https://vuejs.org/"
          >Vue.js</a
        >
        and<a class="btn btn-danger btn-shadow p-1" href="https://graphql.org/"
          >GraphQL</a
        >
        .
      </p>
      <hr class="my-2" />
      <p>
        If you're an avid gamer like me, connect with me through
        <a
          href="https://steamcommunity.com/id/polgoph/"
          class="btn btn-dark btn-shadow mr-1"
          ><i class="fab fa-steam"></i> STEAM</a
        >
        or
        <button class="btn btn-primary btn-shadow" @click="doCopy">
          <i class="fab fa-discord"></i> DISCORD
        </button>
      </p>
      <!-- <p class="lead">
        <a class="btn btn-primary btn-lg" href="#!" role="button"
          >Some action</a
        >
      </p> -->
    </div>
  </div>
</template>

<script>
export default {
  name: "About",
  data: function() {
    return {
      message: "PaulGo#3458",
    };
  },
  methods: {
    doCopy: function() {
      this.$copyText(this.message).then(
        function(e) {
          alert("Copied Discord Id to Clipboard - PaulGo#3458");
          console.log(e);
        },
        function(e) {
          alert("Can not copy");
          console.log(e);
        }
      );
    },
  },
  components: {},
};
</script>
<style scoped>
.js {
  background: #f7df1e;
  color: #181818;
  font-weight: bold;
}
.gql {
  background: #e535ab;
  color: #181818;
  font-weight: bold;
}
.vjs {
  background: #42b883;
  color: #181818;
  font-weight: bold;
}
.main {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
}

#shapesfour {
  position: absolute;
  width: 100%;
  height: 70%;
  left: 0px;
  top: 130%;
  z-index: -1;
}
#shapesfive {
  position: absolute;
  width: 20%;

  left: -10%;
}

#shapessix {
  position: absolute;
  width: 100%;
  height: 50%;
  top: 250%;
  left: 0px;
  z-index: -1;
}
</style>
